import React, {useEffect, useState} from 'react';
import '../assets/styles/common/base.scss';
import '../assets/styles/pages/_contact-us.scss';
import Select from 'react-select';
import ReCAPTCHA from "react-google-recaptcha";
import FindAgentBlock from "../components/FindAgentBlock";
import InputMask from 'react-input-mask';
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import configActions from "../store/actions/config";
import axios from "axios";
const recaptchaRef = React.createRef();

const ContactUs = () => {
    const configStore = useSelector((store) => store.configStore);
    const dispatch = useDispatch();
    const reCaptchaKey = process.env.REACT_APP_CF_GOOGLE_RECAPTCHA_KEY

    const [formField, setFormField] = useState('email');
    const [formError, setFormError] = useState(null);
    const [formTopics, setFormTopics] = useState(null);
    const [recaptchaValue, setRecaptchaValue] = useState('');
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    const setMessageValue = (value) => {
        dispatch(configActions.setFormMessage(value));
        dispatch(configActions.setFormMessageError(''));
    }
    const setPolicyValue = (value) => {
        dispatch(configActions.setFormPolicy(value));
    }
    const setPhoneValue = (value) => {
        dispatch(configActions.setFormPhone(value));
        dispatch(configActions.setFormPhoneError(''));
    }
    const setEmailValue = (value) => {
        dispatch(configActions.setFormEmail(value));
        dispatch(configActions.setFormEmailError(''));
    }
    const setNameValue = (value) => {
        dispatch(configActions.setFormName(value));
        dispatch(configActions.setFormNameError(''));
    }
    const handleSelect = (selectedOption) => {
        dispatch(configActions.setFormTopic(selectedOption));
        dispatch(configActions.setFormTopicError(''));
    };
    const setCaptcha = () => {
        setRecaptchaValue(recaptchaRef.current.getValue());
    }

    const formSubmit = (event) => {
        event.preventDefault();
        dispatch(configActions.setFormTopicError(''));
        dispatch(configActions.setFormMessageError(''));
        dispatch(configActions.setFormEmailError(''));
        dispatch(configActions.setFormPhoneError(''));
        dispatch(configActions.setFormNameError(''));

        let formValid = true;
        let formErrorList = [];
        setFormError('');

        if (configStore.formTopic.length <= 0) {
            formValid = false;
            formErrorList.push('form-topic');
            dispatch(configActions.setFormTopicError('Choose a topic'));
        }

        if (configStore.formMessage.length === 0) {
            formValid = false;
            formErrorList.push('form-message');
            dispatch(configActions.setFormMessageError('This field is required and cannot be empty'));
        } else if (configStore.formMessage.length < 10) {
            formValid = false;
            formErrorList.push('form-message');
            dispatch(configActions.setFormMessageError('The message should be at least 10 symbols long'));
        }

        if (formField === 'email') {
            if (configStore.formEmail.length < 1) {
                formValid = false;
                formErrorList.push('form-email');
                dispatch(configActions.setFormEmailError('This field is required'));
            }
        } else if (formField === 'phone') {
            if (configStore.formPhone.length < 1){
                formValid = false;
                formErrorList.push('form-phone');
                dispatch(configActions.setFormPhoneError('This field is required'));
            }
        }

        if (configStore.formEmail.length > 0 && !configStore.formEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)){
            formValid = false;
            formErrorList.push('form-email');
            dispatch(configActions.setFormEmailError('Enter correct email'));
        }

        if (configStore.formPhone.length > 0 && configStore.formPhone.toString().slice(-1) === '_') {
            formValid = false;
            formErrorList.push('form-phone');
            dispatch(configActions.setFormPhoneError('Enter correct phone'));
        }

        if (configStore.formName.length < 3) {
            formValid = false;
            formErrorList.push('form-name');
            dispatch(configActions.setFormNameError('Enter your name'));
        }

        if (formValid) {
            sendForm();
        } else {
            document.getElementById(formErrorList[0]).scrollIntoView({block: "center", behavior: "smooth"});
        }
    }

    const sendForm = () => {
        dispatch(configActions.setContactUsLoading(true))
        let contactPreference = 0;
        if (formField !== 'email'){
            contactPreference = 1;
        }
        const today = new Date().toJSON();
        const data = {
            "topic": `/api${configStore.formTopic.value}`,
            "subject": configStore.formTopic.label,
            "content": configStore.formMessage,
            "sentFrom": "Contact Us Page",
            "name": configStore.formName,
            "number": configStore.formPolicy,
            "contactPreference": contactPreference,
            "phone": configStore.formPhone,
            "email": configStore.formEmail,
            "createdAt": today,
            "updatedAt": today,
        };

        axios.post(`${process.env.REACT_APP_API_BASE_URI}email_histories`, data, { headers })
            .then(() => formResult()).catch((err) => formError(err));

        const formResult = () => {
            dispatch(configActions.setContactUsLoading(false))
            dispatch(configActions.setFormTopic(''));
            dispatch(configActions.setFormMessage(''));
            dispatch(configActions.setFormPolicy(''));
            dispatch(configActions.setFormPhone(''));
            dispatch(configActions.setFormEmail(''));
            dispatch(configActions.setFormName(''));
            window.grecaptcha.reset();
            dispatch(configActions.setModalSuccessOpen(true));
            document.getElementsByTagName('body')[0].classList.add('modal-open');
        }

        const formError = (err) => {
            console.log(err)
            if (err.response.data.detail) {
                setFormError(err.response.data.detail);
            } else {
                setFormError('An error occurred, please try again later')
            }

            dispatch(configActions.setContactUsLoading(false))
        }
    }

    const modalSuccessClose = () => {
        dispatch(configActions.setModalSuccessOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URI}email_topics?hidden=false`, { headers })
            .then((response) => {
                // API Platform returns data in hydra:member format
                const topics = response.data['hydra:member'] || response.data || [];
                setTopics(topics);
            });
        setMessageValue('');
        setPolicyValue('');
        setPhoneValue('');
        setEmailValue('');
        setNameValue('');
        handleSelect('');
    }, [])

    const setTopics = (topics) => {
        let topicsList = [];
        topics.forEach((el) => {
            topicsList.push({value : '/email_topics/' + el.id, label : el.topic.name})
        })
        setFormTopics(topicsList);
    }


    return (
        <>
            <div className='contact-us'>
                <div className="container">
                    <div className='ask'>
                        <h2 className='question-title'>
                            Ask a Question
                        </h2>
                        <p className='question-text'>
                            Send us your question and we will get back with you right away. If you need to file a claim, please visit our <Link to='/claims'>Claims Center.</Link>
                        </p>
                        <form onSubmit={(ev) => {formSubmit(ev)}} className="form">
                            <div className={`form-group ${configStore.formTopicError.length > 0 ? 'error' : ''}`} id="form-topic">
                                <div className="label">Choose a topic</div>
                                <Select
                                    className='form-select react-select'
                                    value={configStore.formTopic}
                                    onChange={handleSelect}
                                    options={formTopics}
                                    placeholder='Select topic'
                                />
                                {configStore.formTopicError.length > 0 &&
                                    <div className="input-error">{configStore.formTopicError}</div>
                                }
                            </div>
                            <div className={`form-group ${configStore.formMessageError.length > 0 ? 'error' : ''}`} id="form-message">
                                <div className="label">Describe your question</div>
                                <textarea
                                    placeholder='Enter question'
                                    className='form-textarea'
                                    onChange={(ev) => setMessageValue(ev.target.value)}
                                    onBlur={(ev) => setMessageValue(ev.target.value.trim())}
                                    value={configStore.formMessage}
                                />
                                {configStore.formMessageError.length > 0 &&
                                    <div className="input-error">{configStore.formMessageError}</div>
                                }
                            </div>
                            <div className="form-group">
                                <div className="label">Your policy or account number (optional)</div>
                                <input
                                    placeholder='Enter related policy or account number'
                                    className='form-input'
                                    onChange={(ev) => setPolicyValue(ev.target.value)}
                                    value={configStore.formPolicy}
                                />
                            </div>
                            <div className="form-group">
                                <div className="label">How should we respond to you</div>
                                <div className='form-radio-group'>
                                    <label className='form-radio'>
                                        <input
                                            type="radio"
                                            name="contact"
                                            value="email"
                                            className='form-radio'
                                            onChange={(e) => (setFormField(e.target.value))}
                                            defaultChecked
                                        />
                                        <div className="radio-box"/>
                                        <div className="radio-text">By email</div>
                                    </label>
                                    <label className='form-radio'>
                                        <input
                                            type="radio"
                                            name="contact"
                                            value="phone"
                                            className='form-radio'
                                            onChange={(e) => (setFormField(e.target.value))}
                                        />
                                        <div className="radio-box"/>
                                        <div className="radio-text">By telephone</div>
                                    </label>
                                </div>
                            </div>
                            <div className={`form-group ${configStore.formPhoneError.length > 0 ? 'error' : ''}`} id="form-phone">
                                <div className="label">Your phone number</div>
                                <InputMask
                                    mask="(999) 999-9999"
                                    className='form-input'
                                    placeholder='(555) 555-5555'
                                    onChange={(ev) => setPhoneValue(ev.target.value)}
                                    value={configStore.formPhone}
                                />
                                {configStore.formPhoneError.length > 0 &&
                                <div className="input-error">{configStore.formPhoneError}</div>
                                }
                            </div>
                            <div className={`form-group ${configStore.formEmailError.length > 0 ? 'error' : ''}`} id="form-email">
                                <div className="label">Your email</div>
                                <input
                                    placeholder='Enter your email address'
                                    className='form-input'
                                    onChange={(ev) => setEmailValue(ev.target.value)}
                                    value={configStore.formEmail}
                                />
                                {configStore.formEmailError.length > 0 &&
                                <div className="input-error">{configStore.formEmailError}</div>
                                }
                            </div>
                            <div className={`form-group ${configStore.formNameError.length > 0 ? 'error' : ''}`} id="form-name">
                                <div className="label">Your name</div>
                                <input
                                    placeholder='Enter your name'
                                    className='form-input'
                                    onChange={(ev) => setNameValue(ev.target.value)}
                                    onBlur={(ev) => setNameValue(ev.target.value.trim())}
                                    value={configStore.formName}
                                />
                                {configStore.formNameError.length > 0 &&
                                <div className="input-error">{configStore.formNameError}</div>
                                }
                            </div>
                            <div className="form-captcha">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="normal"
                                    sitekey="6Ldn930UAAAAACn_tkcxOq1t7Ku9j24GuSrgwbTL"
                                    onChange={() => {setCaptcha()}}
                                />
                            </div>
                            <button type='submit'
                                    className={`form-submit button-gradient 
                                    ${recaptchaValue.length < 1 ? 'disabled' : ''}
                                    ${configStore.isContactUsLoading ? 'is-loading' : ''}`} >
                                <span>Send</span>
                            </button>
                            <div className="form-error">{formError}</div>
                        </form>
                    </div>
                    <div className='touch'>
                        <div className="touch-heading">
                            <div className="touch-heading-text">
                                <h3 className='question-title'>
                                    Get in Touch with Us
                                </h3>
                                <p className='question-text'>
                                    Contact us in a way convenient for{'\u00A0'}you.
                                </p>
                            </div>
                            <div className="touch-heading-image">
                                <img
                                    src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/phone.png`}/>
                            </div>
                        </div>
                        <div className='touch__logIn'>
                            <img
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/my-rvos.png`}
                                className='touch__img'
                            />
                            <p className='touch__text'>
                                You may
                                <a href={process.env.REACT_APP_SIGN_IN_URI || 'https://my.rvos.com/sign/in'} className='touch__link' target="_blank" rel="noopener noreferrer">{' '}log in{' '}</a>
                                to your MyRVOS account to view your policy information, check claim status, and view
                                billing details.
                            </p>
                        </div>
                        <div className='touch__contacts'>
                            <div className='card'>
                                <img
                                    src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/phone.svg`}
                                    className='touch__icon'
                                />
                                <div>
                                    <h4 className='card__title'>
                                        Phone Number
                                    </h4>
                                    <p className='card__text'>
                                        <a href="tel:18007923084">1-800-792-3084</a>
                                    </p>
                                    <p className='card__text'>
                                        Fax: 254-773-1122
                                    </p>
                                </div>
                            </div>
                            <div className='card'>
                                <img
                                    src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/address.svg`}
                                    className='touch__icon'
                                />
                                <div>
                                    <h4 className='card__title'>
                                        Mailing Address
                                    </h4>
                                    <p className='card__text'>
                                        PO Box 6106
                                    </p>
                                    <p className='card__text'>
                                        Temple, TX 76503-6106
                                    </p>
                                </div>
                            </div>
                            <div className='card'>
                                <img
                                    src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/emergency.svg`}
                                    className='touch__icon'
                                />
                                <div>
                                    <h4 className='card__title'>
                                        Emergency Claims
                                    </h4>
                                    <p className='card__text'>
                                        <a href="tel:18007923084">1-800-792-3084</a>
                                    </p>
                                    <Link to='/claims' className='card__btn'>visit our claim center</Link>
                                </div>
                            </div>
                            <div className='card'>
                                <img
                                    src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/questions.svg`}
                                    className='touch__icon'
                                />
                                <div>
                                    <h4 className='card__title'>
                                        Still have questions?
                                    </h4>
                                    <p className='card__text'>
                                        Search for answers in the Info Center
                                    </p>
                                    <Link to='/info-center' className='card__btn'>Visit our info center</Link>
                                </div>
                            </div>
                        </div>
                        <p className='touch__text'>
                            For changes to your policy or coverage inquiries, please
                            <Link to='/find-an-agent' className='touch__link'>{' '}contact your agent.</Link>
                        </p>
                        <div className='touch__general-img'>
                            <img
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/phone.png`}
                            />
                        </div>
                    </div>
                </div>
                <div className={`modal-success ${configStore.modalSuccessOpen ? 'open' : ''}`}>
                    <div className="modal-success-container">
                        <button type="button" className="button-close" onClick={() => modalSuccessClose()}>
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`}/>
                        </button>
                        <img className="modal-success-image" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/icon-success.svg`}/>
                        <div className="modal-success-title">Done!</div>
                        <div className="modal-success-text">Your message has been sent.</div>
                        <button className="modal-success-btn button-gradient" onClick={() => modalSuccessClose()}>Back To Contact Us</button>
                    </div>
                </div>
            </div>
            <FindAgentBlock/>
        </>
    )
};

export default ContactUs;
